import { jsxs as d, jsx as p } from "react/jsx-runtime";
import { c as C } from "react/compiler-runtime";
import { DialogTitle as N, DialogContent as b, Typography as k, Button as h, DialogActions as L, Dialog as _ } from "@mui/material";
import { dialogStyles as y } from "../styles.js";
const S = (P) => {
  const e = C(18), {
    open: g,
    onClose: t,
    onConfirm: f,
    planToDelete: D,
    customPlanName: u
  } = P;
  let l;
  e: {
    if (D === void 0) {
      l = "Plan Image";
      break e;
    }
    switch (D) {
      case "FLOOR_PLAN": {
        l = "Floor Plan image";
        break e;
      }
      case "RF_PLAN": {
        l = "RF Plan image";
        break e;
      }
      case "SINR_PLAN": {
        l = "SINR Plan image";
        break e;
      }
      case "DOMINANT_CELL_PLAN": {
        l = "Dominant Cell Plan image";
        break e;
      }
      case "CUSTOM_PLAN": {
        l = `${u || "Custom"} image`;
        break e;
      }
      default:
        l = "Plan Image";
    }
  }
  const o = l;
  let s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = {
    "& .MuiDialog-paper": y.resetDialog.paper
  }, e[0] = s) : s = e[0];
  let a;
  e[1] !== o ? (a = /* @__PURE__ */ d(N, { children: [
    "Delete ",
    o,
    " image?"
  ] }), e[1] = o, e[2] = a) : a = e[2];
  let i;
  e[3] !== o ? (i = /* @__PURE__ */ p(b, { children: /* @__PURE__ */ d(k, { children: [
    "You will need to re-upload the ",
    o,
    " image to add it back.",
    " ",
    `
`,
    "Do you want to proceed?"
  ] }) }), e[3] = o, e[4] = i) : i = e[4];
  let n;
  e[5] !== t ? (n = /* @__PURE__ */ p(h, { onClick: t, children: "Cancel" }), e[5] = t, e[6] = n) : n = e[6];
  let r;
  e[7] !== f ? (r = /* @__PURE__ */ p(h, { onClick: f, color: "primary", variant: "contained", children: "Delete" }), e[7] = f, e[8] = r) : r = e[8];
  let c;
  e[9] !== n || e[10] !== r ? (c = /* @__PURE__ */ d(L, { children: [
    n,
    r
  ] }), e[9] = n, e[10] = r, e[11] = c) : c = e[11];
  let m;
  return e[12] !== t || e[13] !== g || e[14] !== a || e[15] !== i || e[16] !== c ? (m = /* @__PURE__ */ d(_, { open: g, onClose: t, maxWidth: "xs", fullWidth: !0, container: document.body, sx: s, children: [
    a,
    i,
    c
  ] }), e[12] = t, e[13] = g, e[14] = a, e[15] = i, e[16] = c, e[17] = m) : m = e[17], m;
};
export {
  S as DeletePlanDialog
};
